module.exports = __webpack_public_path__ + "img/banner-ita-spa.f5e4d095.jpg";